//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('clientManagementController', ['$scope', 'organizations', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialogMessage', '$state', 'authService', '$q', 'fileReader',
      'providers', 'clientSelectService',
      function ($scope, organizations, $stateParams, progressBar, ngDialog, uiGridConstants,
        commonDialogMessage, $state, authService, $q, fileReader, providers, clientSelectService) {
        let readyToUpload = false;
        let selectedFilename = null;
        let gridData;
        $scope.showAllClients = organizations.getShowAll();
        const progress = progressBar.getProgressBar();
        $scope.organization = {
          Name: null,
          AddressLine1: null,
          AddressLine2: null,
          City: null,
          PostalCode: null,
          Country: null,
          StateProv: null,
          IsTravelAgency: false,
          Id: 0,
          TravelAgencyId: 0,
          AllowOpenBookings: false,
          AllowFbChat: false,
          Domains: {
            Id: 0,
            OrganizationId: 0,
            Name: null,
          },
          TripLinkAccounts: {
            Id: 0,
            OrganizationId: 0,
            Login: null,
            Password: null,
            ProviderId: 20,
            DataFetched: null,
          },
          AcceptEmails: {
            Id: 0,
            Email: null,
            OrganizationId: 0,
            IsAdmin: false,
          },
          LogoImageLink: '//:0'
        };
        $scope.isEdit = false;
        $scope.isNew = false;
        $scope.isTripLink = false;
        $scope.currentDate = new Date();
        $scope.domainList = [{
          Id: 0,
          Name: '',
          OrganizationId: 0,
        },];
        $scope.tripLinkAccountList = [{
          Id: 0,
          OrganizationId: 0,
          Login: '',
          Password: '',
          ProviderId: 20,
          DataFetched: $scope.currentDate,
        },];
        $scope.acceptEmailList = [{
          Id: 0,
          Email: '',
          OrganizationId: 0,
          IsAdmin: false,
        },];
        $scope.travelAgencySelId = 0;
        $scope.searchClients = function () {
          organizations.setShowAll($scope.showAllClients);
          setGridData();
        };

        organizations.getCountries().then(function (responseData) {
          $scope.countryList = responseData.data;
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${err.statusText}</p>`;
              $scope.errTitle = 'Client Error';
            },],
          });
        });

        $scope.countryName = 'United States';
        organizations.getStates().then(function (responseData) {
          $scope.stateList = responseData.data;
        }, function (err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${err.statusText}</p>`;
              $scope.errTitle = 'Client Error';
            },],
          });
        });

        $scope.stateName = '';
        //Call this code while Edit organization
        let id = $stateParams.id;
        if (!!id) {
          getOrganizationById(id);
          $scope.isEdit = true;
        } else {
          organizations.getAgencies().then(function (response) {
            const agencies = response.data;
            $scope.travelAgencyList = agencies.map(function (organization) {
              return {
                Id: organization.Id,
                Name: organization.Name,
              };
            });
          });
        }

        $scope.bookingToolList = ['None', 'Obex Form', 'Concur', 'Deem'];

        function uploadImage(img) {
          if (img != null) {
            return providers.uploadImage(img).then(function (result) {
              const cloudinaryObj = result.data;
              const public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
              return providers.transformImage(public_filename).then(function (result) {
                return result.data;
              });
            });
          }
        };

        function deletePreviousImage(img) {
          if (img != null) {
            return providers.deleteImage(img).then(function (result) {
              return result.data;
            });
          }
        };

        // Validate trip link account , domian , accept email
        function validateEmailPass(addUpdate, addDomain, addEmail, addAccount) {
          let validateMessage = '';
          let inValidDomainList = null;
          let inValidEmailList = null;
          const emailRegex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
          const domainRegex = /(^(https?):\/\/|^)(([^\.]+)\.([^\.]+\.[^\/$]+)|([^\.]+\.[^\/$]+))\/?$/;
          // Validate domain name and email address details while save /update.
          if (addUpdate) {
            if (!$scope.domainList[0].Name && !$scope.acceptEmailList[0].Email) {
              validateMessage = 'Either one domain name or one email address must be entered.';
              return validateMessage;
            };
            // validate domain name
            inValidDomainList = $scope.domainList.filter(function (domainlist) {
              return ((!domainRegex.test(domainlist.Name)) && (!!domainlist.Name));
            });

            if (!!inValidDomainList.length) {
              validateMessage = 'Entered domain name is invalid.';
              return validateMessage;
            };
            // validate accept email list
            inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
              return ((!emailRegex.test(emailList.Email)) && (!!emailList.Email));
            });

            if (!!inValidEmailList.length) {
              validateMessage = 'Entered email address is invalid.';
              return validateMessage;
            };
          };
          // validate domain name while adding new entry
          if (addDomain) {
            inValidDomainList = $scope.domainList.filter(function (domainlist) {
              return (!domainRegex.test(domainlist.Name));
            });

            if (!!inValidDomainList.length) {
              validateMessage = 'Valid domain name must be entered, before adding new entry.';
              return validateMessage;
            }
          };
          // validate email while adding new entry
          if (addEmail) {
            inValidEmailList = $scope.acceptEmailList.filter(function (emailList) {
              return (!emailRegex.test(emailList.Email));
            });

            if (!!inValidEmailList.length) {
              validateMessage = 'Valid email address must be entered, before adding new entry.';
              return validateMessage;
            }
          };
          // Validate trip link account details if added any new row
          if (addAccount) {
            if ($scope.isTripLink) {
              let inValidTripEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
                return ((!emailRegex.test(tripLinkEmail.Login)) || (!passwordRegex.test(tripLinkEmail.Password)));
              });

              if (!!inValidTripEmailList.length) {
                validateMessage =
                  'Valid trip link account details must be entered,when trip link account entry added. Password must contain minimum 8 characters, and must include 1 uppercase letter and 1 digit.';
                return validateMessage;
              };
            };
          };

          return validateMessage;
        };
        // code for upload image
        $scope.getFile = function () {
          fileReader.readAsDataUrl($scope.file, $scope)
            .then(function (result) {
              $scope.organization.LogoImageLink = result;
            });
        };

        $scope.setFile = function (event) {
          selectedFilename = event.target.files[0];
          readyToUpload = true;
          fileReader.readAsDataUrl(selectedFilename, $scope)
            .then(function (result) {
              $scope.organization.LogoImageLink = result;
            });

          $scope.$apply();
        };

        $scope.clearFile = function () {
          readyToUpload = false;
          selectedFilename = null;
          $scope.organization.LogoImageLink = '//:0';
        };

        $scope.saveOrganization = function () {
          if ($scope.orgForm.$valid) {
            let validateEmailPassChk = validateEmailPass(true, false, false, true);
            if (!validateEmailPassChk) {
              let organization = $scope.organization;
              let domainList = $scope.domainList.filter(function (domain) {
                return (!!domain.Name);
              });

              organization.Domains = ((!!domainList.length) ? domainList : []);
              organization.Country = $scope.countryName;
              organization.StateProv = $scope.stateName;
              let acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
                return (!!acceptEmail.Email);
              });

              organization.AcceptEmails = ((!!acceptEmailList.length) ? acceptEmailList : []);
              let tripLinkEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
                return ((!!tripLinkEmail.Login) && (!!tripLinkEmail.Password));
              });

              organization.BookingToolName = $scope.organization.BookingToolName === 'None' ? '' : $scope.organization.BookingToolName;

              organization.TripLinkAccounts = ((!!tripLinkEmailList.length && $scope.isTripLink) ?
                tripLinkEmailList : []);
              organization.TravelAgencyId = authService.getLoginMember().Role === 2 ? authService.getLoginMember().OrganizationId : $scope.travelAgencySelId;
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
                uploadImage(selectedFilename).then(function (result) {
                  if (result != null) {
                    $scope.organization.LogoImageLink = result;
                    addClient($scope.organization);
                  }
                });
              } else {
                //$scope.organization.LogoImageLink = null;
                $scope.organization.LogoImageLink = $scope.PrevLogoImageLink;
                addClient($scope.organization);
              }
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${validateEmailPassChk}</p>`;
                  $scope.errTitle = 'Client Warning';
                },],
              });
            }
          }
        };

        function addClient(client) {
          progress.start();
          organizations.addOrganization(client).then(function () {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.successMsg = 'The Client has been added succesfully.';
                $scope.strTitle = 'Add Client Success';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.clientManagement');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}: ${err.data}</p>`;
                $scope.errTitle = 'Organization Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        }

        function getOrganizationById(id) {
          progress.start();
          const promiseClient = organizations.getOrganizationById(id);
          const promiseAgency = organizations.getAgencies();
          $q.all([promiseClient, promiseAgency]).then(function (response) {
            $scope.isEdit = true;
            $scope.isNew = false;
            $scope.message = null;
            $scope.organization = response[0].data;
            console.log('organization ', $scope.organization);
            const agencies = response[1].data;
            $scope.travelAgencyList = agencies.map(function (agency) {
              return {
                Id: agency.Id,
                Name: agency.Name,
              };
            });

            $scope.domainList = ((!!response[0].data.Domains.length) ? response[0].data.Domains : [{
              Id: 0,
              Name: '',
              OrganizationId: 0,
            },]);
            $scope.countryName = response[0].data.Country;
            $scope.PrevLogoImageLink = response[0].data.LogoImageLink;
            $scope.stateName = response[0].data.StateProv;
            $scope.travelAgencySelId = response[0].data.TravelAgencyId;
            $scope.acceptEmailList = ((!!response[0].data.AcceptEmails.length) ? response[0].data.AcceptEmails :
              [{
                Id: 0,
                Email: '',
                OrganizationId: 0,
                IsAdmin: false,
              },]);
            if (!!response[0].data.TripLinkAccounts.length) {
              $scope.isTripLink = true;
              $scope.tripLinkAccountList = response[0].data.TripLinkAccounts;
            } else {
              $scope.isTripLink = false;
            }

            $scope.organization.LogoImageLink = response[0].data.LogoImageLink;
          }, function (err) {

            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Client Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };

        $scope.updateOrganization = function () {
          if ($scope.orgForm.$valid) {
            let validateEmailPassChk = validateEmailPass(true, false, false, true);
            if (!validateEmailPassChk) {
              let organization = $scope.organization;
              let domainList = $scope.domainList.filter(function (domain) {
                return (!!domain.Name);
              });

              organization.Domains = ((!!domainList.length) ? domainList : []);
              organization.Country = $scope.countryName;
              organization.StateProv = $scope.stateName;
              let acceptEmailList = $scope.acceptEmailList.filter(function (acceptEmail) {
                return (!!acceptEmail.Email);
              });

              organization.AcceptEmails = ((!!acceptEmailList.length) ? acceptEmailList : []);
              let tripLinkEmailList = $scope.tripLinkAccountList.filter(function (tripLinkEmail) {
                return ((!!tripLinkEmail.Login) && (!!tripLinkEmail.Password));
              });

              organization.BookingToolName = $scope.organization.BookingToolName === 'None' ? '' : $scope.organization.BookingToolName;

              organization.TripLinkAccounts = ((!!tripLinkEmailList.length && $scope.isTripLink) ?
                tripLinkEmailList : []);
              organization.TravelAgencyId = ((!organization.IsTravelAgency) ? $scope.travelAgencySelId : 0);
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
                uploadImage(selectedFilename).then(function (result) {
                  if (result != null) {
                    if ($scope.PrevLogoImageLink !== null) {
                      let str = $scope.PrevLogoImageLink;
                      let arrResult = str.split("/");
                      let len = arrResult.length - 1;
                      str = arrResult[len];
                      let deletedFileName = str.substring(0, str.indexOf("."));
                      deletePreviousImage(deletedFileName).then(function (result) {
                        console.log(result);
                      });
                    }
                    $scope.organization.LogoImageLink = result;
                    updateClient($scope.organization);
                  }
                });
              } else {
                $scope.organization.LogoImageLink = $scope.PrevLogoImageLink;
                updateClient($scope.organization);
              }
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${validateEmailPassChk}</p>`;
                  $scope.errTitle = 'Update Client Warning';
                },],
              });
            }
          }
        };

        function updateClient(client) {
          progress.start();
          organizations.updateOrganization(client.Id, client).then(function (client) {
              clientSelectService.setSelectedClient(client.config.data.Id, client.config.data.Name, client.config.data.AllowOpenBookings );
              const dialogPut = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = 'The Client has been updated succesfully.';
                  $scope.strTitle = 'Update Client Success';
                },],
              });
              dialogPut.closePromise.then(function (data) {
                $state.go('app.clientManagement');
              });
            }, function (err) {

            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}: ${err.data}</p>`;
                $scope.errTitle = 'Update Client Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        }
        //add new domain entry for organization
        $scope.addDomain = function () {
          let checkDomain = validateEmailPass(false, true, false, false);
          if (!checkDomain) {
            $scope.domainList.push({
              Id: 0,
              Name: '',
              OrganizationId: $scope.organization.Id,
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${checkDomain}</p>`;
                $scope.errTitle = 'Add Domain Warning';
              },],
            });
          }
        };
        //check duplicate domain entry for organization
        $scope.checkDuplicateDomain = function (index, domainName) {
          let domainList = $scope.domainList.filter(function (domain) {
            return (domain.Name == domainName);
          });

          if (domainList.length > 1) {
            const dialogDup = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${commonDialogMessage.duplicateDomainError}</p>`;
                $scope.errTitle = 'Domain Error';
              },],
            });
            dialogDup.closePromise.then(function (data) {
              $scope.domainList[index].Name = '';
            });
          }
        };
        //Remove domain for organization
        $scope.removeDomain = function (index, domainId) {
          if (!domainId) {
            if ($scope.domainList.length > 1) {
              $scope.domainList.splice(index, 1);
            } else {
              if (!!$scope.domainList[0].Name) {
                $scope.domainList.splice(index, 1);
                $scope.domainList.push({
                  Id: 0,
                  Name: '',
                  OrganizationId: $scope.organization.Id,
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${commonDialogMessage.blankDomainError}</p>`;
                    $scope.errTitle = 'Remove Domain Warning';
                  },],
                });
              }
            }
          } else {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Domain?';
                $scope.strMsg = 'Do you really want to delete this domain?';
              },],
            });
            confirm.closePromise.then(function (data) {
              if (data.value === 1) {
                if ($scope.domainList.length > 1) {
                  $scope.domainList.splice(index, 1);
                } else {
                  if (!!$scope.domainList[0].Name) {
                    $scope.domainList.splice(index, 1);
                    $scope.domainList.push({
                      Id: 0,
                      Name: '',
                      OrganizationId: $scope.organization.Id,
                    });
                  } else {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${commonDialogMessage.blankDomainError}</p>`;
                        $scope.errTitle = 'Remove Domain Warning';
                      },],
                    });
                  }
                }
              }
            });
          }
        };
        //add new trip link account entry for organization
        $scope.addAccount = function () {
          if ($scope.isTripLink) {
            let checkEmailPass = validateEmailPass(false, false, false, true);
            if (!checkEmailPass) {
              $scope.isTripLink = true;
              $scope.tripLinkAccountList.push({
                Id: 0,
                OrganizationId: $scope.organization.Id,
                Login: '',
                Password: '',
                ProviderId: 20,
                DataFetched: $scope.currentDate,
              });
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${commonDialogMessage.checkEmailPassMessage}</p>`;
                  $scope.errTitle = 'Add Account Warning';
                },],
              });
            }
          } else {
            $scope.isTripLink = true;
            if (!$scope.tripLinkAccountList.length) {
              $scope.tripLinkAccountList.push({
                Id: 0,
                OrganizationId: $scope.organization.Id,
                Login: '',
                Password: '',
                ProviderId: 20,
                DataFetched: $scope.currentDate,
              });
            }
          }
        };
        //Remove trip link account for organization
        $scope.removeAccount = function (index, triplinkId) {
          if (!triplinkId) {
            if ($scope.tripLinkAccountList.length > 1) {
              $scope.tripLinkAccountList.splice(index, 1);
            } else {
              $scope.tripLinkAccountList.splice(index, 1);
              $scope.isTripLink = false;
            }
          } else {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Account?';
                $scope.strMsg = 'Do you really want to delete this account?';
              },],
            });
            confirm.closePromise.then(function (data) {
              if (data.value === 1) {
                if ($scope.tripLinkAccountList.length > 1) {
                  $scope.tripLinkAccountList.splice(index, 1);
                } else {
                  $scope.tripLinkAccountList.splice(index, 1);
                  $scope.isTripLink = false;
                }
              }
            });
          }
        };
        //chcek duplicate trip link login entry for organization
        $scope.checkDuplicatelogin = function (index, login) {
          let triplinklistData = $scope.tripLinkAccountList.filter(function (triplinklist) {
            return (triplinklist.Login == login);
          });

          if (triplinklistData.length > 1) {
            let dialogDup = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>Entered login name is duplicate in trip link account for this organization</p>`;
                $scope.errTitle = 'Duplicate Login Name Error';
              },],
            });
            dialogDup.closePromise.then(function (data) {
              $scope.tripLinkAccountList[index].login = '';
            });
          }
        };
        //add new email entry for organization
        $scope.addEmail = function () {
          let checkAcceptEmail = validateEmailPass(false, false, true, false);
          if (!checkAcceptEmail) {
            $scope.acceptEmailList.push({
              Id: 0,
              Email: '',
              OrganizationId: $scope.organization.Id,
              IsAdmin: false,
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${checkAcceptEmail}</p>`;
                $scope.errTitle = 'Add Email Warning';
              },],
            });
          }
        };
        //check duplicate email entry for organization
        $scope.checkDuplicateEmail = function (index, email) {
          let acceptEmailData = $scope.acceptEmailList.filter(function (emaillist) {
            return (emaillist.Email == email);
          });

          if (acceptEmailData.length > 1) {
            let dialogDup = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${commonDialogMessage.orgDuplicateEmailMessage}</p>`;
                $scope.errTitle = 'Duplicate Email Error';
              },],
            });
            dialogDup.closePromise.then(function (data) {
              $scope.acceptEmailList[index].Email = '';
              $scope.acceptEmailList[index].IsAdmin = false;
            });
          }
        };
        //Remove email for organization
        $scope.removeEmail = function (index, acceptEmailId) {
          if (!acceptEmailId) {
            if ($scope.acceptEmailList.length > 1) {
              $scope.acceptEmailList.splice(index, 1);
            } else {
              if (!!$scope.acceptEmailList[0].Email) {
                $scope.acceptEmailList.splice(index, 1);
                $scope.acceptEmailList.push({
                  Id: 0,
                  Email: '',
                  OrganizationId: $scope.organization.Id,
                  IsAdmin: false,
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${commonDialogMessage.orgDeleteEmailMessage}</p>`;
                    $scope.errTitle = 'Remove Email Warning';
                  },],
                });
              }
            }
          } else {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Accept Email?';
                $scope.strMsg = 'Do you really want to delete this accept email?';
              },],
            });
            confirm.closePromise.then(function (data) {
              if (data.value === 1) {
                if ($scope.acceptEmailList.length > 1) {
                  $scope.acceptEmailList.splice(index, 1);
                } else {
                  if (!!$scope.acceptEmailList[0].Email) {
                    $scope.acceptEmailList.splice(index, 1);
                    $scope.acceptEmailList.push({
                      Id: 0,
                      Email: '',
                      OrganizationId: $scope.organization.Id,
                      IsAdmin: false,
                    });
                  } else {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${commonDialogMessage.orgDeleteEmailMessage}</p>`;
                        $scope.errTitle = 'Remove Email Warning';
                      },],
                    });
                  }
                }
              }
            });
          }
        };
        // ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            displayName: 'Client Name',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'TravelAgencyName',
            displayName: 'Agency Name',
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
          }, {
            name: 'AddressLine1',
            displayName: 'Address Line 1',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'AddressLine2',
            displayName: 'Address Line 2',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'City',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'StateProv',
            displayName: 'State',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'PostalCode',
            displayName: 'Postal Code',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Inactive',
            displayName: 'Inactive',
            visible: false,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.Inactive" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Inactive" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              },],
            },
          }, {
            name: 'Country',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'AllowOpenBookings',
            displayName: 'Allow Open Booking',
            visible: true,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.AllowOpenBookings" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.AllowOpenBookings" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              },],
            },
          }, {
            name: 'AllowFbChat',
            displayName: 'Allow Fb Chat',
            visible: true,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.AllowFbChat" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.AllowFbChat" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              },],
            },
          }, {
            name: 'BookingToolName',
            displayName: 'Booking Tool',
            visible: true,
            enableSorting: true,
          },],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
              updateGridPagination(gridData);
            });

            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
                if (row.entity.Inactive === true) {
                  $scope.disabledDeleteBtn = false;
                } else {
                  $scope.disabledDeleteBtn = true;
                }
              } else {
                $scope.rowSelecting = false;
                $scope.disabledDeleteBtn = false;
              }
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              updateGridPagination();
            });
          },
        };
        $scope.gridOptions.columnDefs[1].visible = ((authService.getLoginMember().Role === 4) ? true : false);
        $scope.onDblClick = function (row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view();
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        function setGridData() {
          if (authService.getLoginMember().Role === 3) {
            getClientByTravelMangr();
          } else {
            progress.start();
            organizations.getClients($scope.showAllClients).then(function (response) {
              gridData = response.data;
              updateGridPagination(gridData);
            }, function (err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Client Error';
                },],
              });
            })
              .finally(function () {
                progress.complete();
              });
          }
        };

        function updateGridPagination(gridData) {
          $scope.gridOptions.data = gridData;
          $scope.gridOptions.totalItems = gridData.length;
        };

        function getClientByTravelMangr() {
          progress.start();
          organizations.getOrganizations().then(function (response) {
              const clientsData = response.data;
              let clients = [];
              if ($scope.showAllClients === false) {
                clients = clientsData.filter(function(client) { 
                  return client.Inactive === false 
                });
              } else {
                clients = response.data;
              }
              gridData = clients;
			        updateGridPagination(gridData);
            }, function (err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Client Error';
                },],
              });
            })
            .finally(function () {
              progress.complete();
            });
        }

        setGridData();
        $scope.view = function () {
          if (!!$scope.rowSelectingId) {
            getOrganizationById($scope.rowSelectingId);
          }

          ngDialog.open({
            template: 'templates/partials/viewClient.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };

        $scope.deleteOrganization = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Client?';
              $scope.strMsg = 'Do you really want to delete this client?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              organizations.deleteOrganization($scope.rowSelectingId).then(function (response) {
                const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.successMsg = 'The client has been succesfully deleted.';
					            $scope.strTitle = 'Delete Client Success';
                    },],
                  });
                  dialog.closePromise.then(function (data) {});
                }, function (err) {

                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Delete Client Error'; //PLACE HOLDER
                    },],
                  });
                  dialog.closePromise.then(function (data) {});
                })
                .finally(function () {
                  progress.complete();
                  $scope.gridApi.core.clearAllFilters();
                  setGridData();
                });
            }
          });
        };

        $scope.edit = function () {
          $state.go('app.editClient', {
            id: $scope.rowSelectingId,
          });
        };
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/clientManagementController.js